import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'
// 1. Sentryのインポートを追加
import * as Sentry from "@sentry/vue";

const app = createApp(App)

// 2. Sentryの初期化 (app.mountの前に実行)
Sentry.init({
  app,
  dsn: "https://ab409827cdba7419744e326b7c30a0bc@o4511046644924416.ingest.us.sentry.io/4511046766297088",
  
  environment: import.meta.env.MODE,

  // 自社のコードにも依存ライブラリにも存在しない変数のエラー（Chrome iOS が注入するコード由来と見られ、
  // 1人の端末から繰り返し届くだけでアプリの不具合ではない）。この1件だけを送らない
  ignoreErrors: [/Can't find variable: EmptyRanges/],

  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // パフォーマンス監視（どの画面が重いか）の収集率。1.0は100%の意味。
  tracesSampleRate: 1.0, 
  // エラー時の画面再現（リプレイ）の収集率。
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

app.use(router)
app.mount('#app')